/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata>): BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata(), model);
        BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata>): BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata.newInstance(<BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
